define('rebrush/components/blocks/raster-grid/tiles/image',[
    'jquery',
    'cartware/components/_base',
    'cartware/jquery/bem',
    'lodash',
    './helpers/image/center'
], function(
    $,
    Component,
    BEM,
    _,
    ImageCenterHelper
) {
    var BLOCK_NAME = 'raster-grid-item-image';

    return Component.create({
        blocks: null,
        imageCenterHelpers: null,

        constructor: function() {
            this.imageCenterHelpers = [];
        },

        $init: function() {
            var self = this;

            this.blocks = BEM.block(BLOCK_NAME);
            this.blocks.each(function() {
                self.imageCenterHelpers.push(new ImageCenterHelper(this));
            });

            this.hub.on('ui.component.rendering.after', function() {
                _.forEach(self.imageCenterHelpers, function(helper) {
                    helper.layout();
                });
            });
        }
    });
});
